var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5V9.5",
    stroke: "#FF6961",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13451 2.99904L1.63599 12.4986C1.54801 12.6506 1.50161 12.8231 1.50147 12.9987C1.50132 13.1743 1.54743 13.3469 1.63516 13.499C1.7229 13.6512 1.84915 13.7776 2.00123 13.8654C2.1533 13.9533 2.32584 13.9995 2.50147 13.9995H13.4985C13.6741 13.9995 13.8467 13.9533 13.9987 13.8654C14.1508 13.7776 14.2771 13.6512 14.3648 13.499C14.4525 13.3469 14.4986 13.1743 14.4985 12.9987C14.4984 12.8231 14.452 12.6506 14.364 12.4986L8.86545 2.99904C8.77761 2.84728 8.65141 2.72129 8.4995 2.6337C8.3476 2.54611 8.17533 2.5 7.99998 2.5C7.82463 2.5 7.65237 2.54611 7.50046 2.6337C7.34855 2.72129 7.22235 2.84728 7.13451 2.99904V2.99904Z",
    stroke: "#FF6961",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.25C8.27614 12.25 8.5 12.0261 8.5 11.75C8.5 11.4739 8.27614 11.25 8 11.25C7.72386 11.25 7.5 11.4739 7.5 11.75C7.5 12.0261 7.72386 12.25 8 12.25Z",
    fill: "#FF6961",
    stroke: "#FF6961",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.bd18f82b83ac05379ed209b9564157b1.svg";
export { ForwardRef as ReactComponent };